import { Formik } from 'formik'
import React, { useState, useEffect } from 'react'
import { MdSlideshow, MdAddCircle } from 'react-icons/md'
import { Table, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import { AiFillEdit, AiFillDelete, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'


import BtnLoader                from '../buttons/loader/index.js'
import AutoCompleteFields       from '../autoCompleteFields/index.js'
import ControlWithValidation    from '../fields/controlWithValidation/index.js'
import SelectWithValidation     from '../fields/selectWithValidation/index.js'
import SelectWithValidationKeyValeu from '../fields/selectWithValidationKeyValeu/index.js'

// schema validation
import * as schema                  from '../schemaValidation/index.js'

import './styles.css'
import BtnSave from '../buttons/save/index.js'

// define a tabela com os campos do arquivo
const TableFields = ({ fields, setFields, readOnly, setAlert, setShowAlert, delimiter }) => {
    const [tableHidden, setTableHidden] = useState("mf-register-hidden");

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    // name_field e data_type não podem ser alterados
    // se alterado, precisa criar um campo novo
    const [field, setField]     = useState({
        id: '',
        name_field: '',
        data_type: '',
        des_field: '',
        descriptionCode: '',
        mask_field: '',
        LGPD: '',
        example: '',
        status: false
    })


    // if table has fields then show the table 
    useEffect(() => {
        if (fields.length > 0) setTableHidden("")
    }, [fields])

    // salva a linha para que possa ser usado na edição
    const onEditField = (data) => {
        handleShow()
        handleSaveField(data)
    }

    // deleta a linha selecionada da tabela
    const onDeleteField = (row) => {
        if (window.confirm("Deseja remove esse campo?")) {
            const temp  = fields
                            .filter(item => item.id !== row.id)
                            .map((item, index) => ({...item, id: index}))

            handleSaveFields(temp)
        }
    }

    // salva a linha na tabela
    const onSaveField = (data) => {
        setLoading(true)
        var rowsEdit = fields

        // Adicionando IDs para cada objeto do array
        rowsEdit.forEach((item, index) => {
            item.id = index; // Atribuindo IDs incrementais
        });

        data.status = true

        const position = rowsEdit.findIndex(x => x.id === data.id);

        if(position !== -1) {
            rowsEdit = rowsEdit.map((item, index) => (
                (item.id===data.id) ? data : item
            ))
        } else {
            rowsEdit.push(data)
        }

        setLoading(false)
        handleSaveFields(rowsEdit)
        handleClose()
        setTableHidden('')
    }

    // adiciona uma nova linha a tabela
    const handleAddRow = () => {
        handleSaveField({
            id: fields.length, 
            name_field: '', 
            data_type: '', 
            des_field: '', 
            descriptionCode: '', 
            mask_field: '', 
            LGPD: '', 
            example: '', 
            status: false
        })
        handleShow()
    }

    // handle show or close edit/add field
    const handleClose = () => setShow(false);
    const handleShow  = () => setShow(true);

    // edit fields
    const handleSaveFields = (value) => setFields(value);
    // edit field
    const handleSaveField = (value) => setField(value);

    return (
        <div>  

            <UpdateOrCreateField
                handleClose={handleClose} 
                show={show}
                field={field}
                onSaveField={onSaveField}
                schema={schema}
                readOnly={readOnly}
                loading={loading}
            />

            {!readOnly ?
                <AutoCompleteFields 
                    handleSaveFields={handleSaveFields} 
                    setTableHidden={setTableHidden}
                    setAlert={setAlert}
                    setShowAlert={setShowAlert}
                    delimiter={delimiter}
                />
            : null}

            <TableCustom 
                handleAddRow={handleAddRow} 
                tableHidden={tableHidden}
                fields={fields}
                onEditField={onEditField}
                onDeleteField={onDeleteField}
                readOnly={readOnly} />

        </div>
    )
}


// define um campo da tabela de campos do arquivo
const UpdateOrCreateField = ({ 
    field, 
    onSaveField, 
    schema, 
    handleClose, 
    show,
    readOnly=false,
    loading
}) => {

    const getMonth = (mask_field) => {
        let response = ""
        if (mask_field.includes("%b")) {
            response = "%b"
        } else if (mask_field.includes("%B")) {
            response = "%B"
        } else if (mask_field.includes("%m")) {
            response = "%m"
        }
        return response
    }

    const getSequence = (mask_field) => {
        const delimiterDateLenght = getDelimiterDate(mask_field).replace("sem separador", "").length
        const sequence = (delimiterDateLenght > 0) ? mask_field.substring(0, 8) : mask_field.substring(0, 6)
        return sequence.replace("%Y", "ano").replace("%d", "dia").replace("%m", "mes").replace("%b", "mes").replace("%B", "mes")
    }

    const getDelimiterDate = (mask_field) => {
        let response = "sem separador"
        if (mask_field.includes("-")) {
            response = "-"
        } else if (mask_field.includes("/")) {
            response = "/"
        } else if (mask_field.includes(".")) {
            response = "."
        }

        return response
    }

    const getDelimiterTime = (mask_field) => {
        let response = "sem separador"
        if (mask_field.includes(":")) {
            response = ":"
        }

        return response
    }

    const getDelimiterDateTime = (mask_field) => {
        let response = "sem separador"
        if (mask_field.includes("_")) {
            response = "_"
        } else if (mask_field.includes("T")) {
            response = "T"
        } else if (mask_field.includes("t")) {
            response = "t"
        } else if (mask_field.includes(",")) {
            response = ","
        } else if (mask_field.includes(" ")) {
            response = " "
        }

        return response
    }

    const getBooleanTrue = (mask_field) => {
        let response = ""
        const data_field = mask_field.split("|")
        if (data_field.length === 2) {
            response = data_field[0]
        }
        return response
    }

    const getBooleanFalse = (mask_field) => {
        let response = ""
        const data_field = mask_field.split("|")
        if (data_field.length === 2) {
            response = data_field[1]
        }
        return response
    }

    const buildMaskDateTime = (values, option="date") => {
        const dateNow = new Date();
        const monthOfYear = {
            "": "",
            "01": "january",
            "02": "febuary",
            "03": "march",
            "04": "april",
            "05": "may",
            "06": "june",
            "07": "july",
            "08": "august",
            "09": "september",
            "10": "october",
            "11": "november",
            "12": "december"
        }

        // date
        const twoDigitsMonth = ("0" + (dateNow.getMonth() + 1)).slice(-2)
        const abbreviatedMonth = monthOfYear[twoDigitsMonth].slice(0, 3)
        const fullMonth = monthOfYear[twoDigitsMonth]
        const day = dateNow.getDate().toString()
        const year = dateNow.getFullYear().toString()
        const month = values.month.replace("%m", twoDigitsMonth).replace("%b", abbreviatedMonth).replace("%B", fullMonth)
    
        // time
        const hours = ("0" + dateNow.getHours()).slice(-2)
        const minutes = ("0" + dateNow.getMinutes()).slice(-2)
        const seconds = ("0" + dateNow.getSeconds()).slice(-2)
        //transformations
        const delimiterDate = values.delimiterDate.replace("sem separador", "")
        const delimiterTime = values.delimiterTime.replace("sem separador", "")
        const delimiterDateTime = values.delimiterDateTime.replace("sem separador", "")
        // fix bug old/new date delimiter
        if(getDelimiterDate(values.mask_field) !== values.delimiterDate && values.sample_mask.length > 0) {
            values.sequence = ""
            values.sample_mask = ""
        }
    
        const sequences = [
            "",
            "ano"+delimiterDate+"mes"+delimiterDate+"dia",
            "ano"+delimiterDate+"dia"+delimiterDate+"mes",
            "dia"+delimiterDate+"mes"+delimiterDate+"ano",
            "mes"+delimiterDate+"dia"+delimiterDate+"ano"
        ]
    
        const monthOptions = [
            {"value":"", "option":""},
            {"value": "%m", "option": twoDigitsMonth + " (mês com dois dígitos)"},
            {"value": "%b", "option": abbreviatedMonth + " (nome do mês abreviado)"},
            {"value": "%B", "option": fullMonth + " (nome do mês completo)"}
        ]
    
        if (option=="date" && values.sequence.length > 0) {
            values.sample_mask = values.sequence.replace("ano", year).replace("mes", month).replace("dia", day)
            values.mask_field = values.sequence.replace("ano", "%Y").replace("dia", "%d").replace("mes", values.month)
        } else if (option=="datetime" && values.sequence.length > 0) {
            values.sample_mask = values.sequence.replace("ano", year).replace("mes", month).replace("dia", day) + delimiterDateTime + hours + delimiterTime + minutes + delimiterTime + seconds
            values.mask_field = values.sequence.replace("ano", "%Y").replace("dia", "%d").replace("mes", values.month) + delimiterDateTime + "%H" + delimiterTime + "%M" + delimiterTime + "%S"
        }
    
        return {sequence: sequences, monthOptions: monthOptions}
    }
    

    return (
        <Modal
            dialogClassName="tf-main-modal"
            show={show}
            onHide={handleClose}
            animation={true}
            centered >
            <Modal.Header closeButton>
                <Modal.Title>Editando campo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        id: field.id, 
                        name_field: field.name_field, 
                        data_type: field.data_type, 
                        des_field: field.des_field,
                        descriptionCode: field.descriptionCode,
                        mask_field: field.mask_field, 
                        LGPD: field.LGPD, 
                        example: field.example,
                        month: getMonth(field.mask_field),
                        delimiterDate: getDelimiterDate(field.mask_field),
                        sequence: getSequence(field.mask_field),
                        sample_mask: "",
                        booleanFalse: getBooleanFalse(field.mask_field),
                        booleanTrue: getBooleanTrue(field.mask_field),
                        delimiterDateTime: getDelimiterDateTime(field.mask_field),
                        delimiterTime: getDelimiterTime(field.mask_field)
                    }}
                    validationSchema={schema.fieldSchema}
                    onSubmit={(values) => onSaveField(values)}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit} id="fooId">
                        <RowsField
                            values={values}
                            errors={errors}
                            schema={schema}
                            readOnly={readOnly}
                            handleChange={handleChange}
                            buildMaskDateTime={buildMaskDateTime}
                        />

                        {!readOnly ?
                            <div className="mf-register-fields-container-btn">
                                <BtnLoader
                                    loading={loading}
                                    messageNotLoading="Salvar"
                                    messageLoading="Salvando"
                                    style={"btn-loader-135px"}
                                    variant={"success"}
                                />
                            </div>
                        : null}
                    </Form>
                )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}




/**
 * FORMS
 * define o formulario do arquivo
 */
const RowsField = ({
    values,
    schema,
    errors,
    handleChange,
    readOnly=false,
    buildMaskDateTime
}) => {

    let optionsMask = [];

    if (values.data_type === 'integer') {
        optionsMask = [{"value":"", "option":""}, {"value": "#", "option":"99999..."}, {"value":"#.###", "option":"999.999,99"}, {"value":"#,###", "option":"999,999.99"}]
    } else if (values.data_type === 'float') {
        optionsMask = [{"value":"", "option":""}, {"value": "#.#", "option":"99999.99"}, {"value":"#,#", "option":"9999,99"}, {"value":"#.###,##", "option":"999.999,99"}, {"value":"#,###.##", "option":"999,999.99"}]
    }

    return (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="ID"
                name="id"
                placeholder=""
                value={values.id}
                error={errors.id}
                handleChange={handleChange}
                typeColumn="xs"
                valueColumn={1}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="Nome do campo"
                name="name_field"
                placeholder=""
                value={values.name_field}
                error={errors.name_field}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation
                key="type"
                Col={Col}
                type="text"
                label="Tipo do dado"
                name="data_type"
                placeholder=""
                value={values.data_type}
                error={errors.data_type}
                handleChange={handleChange}
                options={["", "string", "integer", "float", "boolean", "date", "datetime"]}
                typeColumn="xs"
                valueColumn={2}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="Descrição do campo"
                name="des_field"
                placeholder=""
                value={values.des_field}
                error={errors.des_field}
                handleChange={handleChange}
                readOnly={readOnly}
            />

        </Row>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="Descrição dos tipos de código"
                name="descriptionCode"
                placeholder=""
                value={values.descriptionCode}
                error={errors.descriptionCode}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation
                key="LGPD"
                Col={Col}
                type="text"
                label="LGPD"
                name="LGPD"
                placeholder=""
                value={values.LGPD}
                error={errors.LGPD}
                handleChange={handleChange}
                options={["", "Não", "Sim"]}
                typeColumn="xs"
                valueColumn={2}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="Exemplo"
                name="example"
                placeholder=""
                value={values.example}
                error={errors.example}
                handleChange={handleChange}
                readOnly={readOnly}
            />

        </Row>
        <Row className="mb-3">

            {values.data_type === 'date' ? 
                <RowsMaskDate
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    readOnly={readOnly}
                    buildMaskDateTime={buildMaskDateTime}
                />
            : null}

            {values.data_type === 'datetime' ? 
                <RowsMaskDatetime
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    readOnly={readOnly}
                    buildMaskDateTime={buildMaskDateTime}
                />
            : null}

            {values.data_type === 'integer' || values.data_type === 'float' ? 
                <SelectWithValidationKeyValeu
                    key="mask_field"
                    Col={Col}
                    type="text"
                    label={"Máscara do tipo " + values.data_type} 
                    name="mask_field"
                    placeholder=""
                    value={values.mask_field}
                    error={errors.mask_field}
                    handleChange={handleChange}
                    options={optionsMask}
                    typeColumn="xs"
                    valueColumn={4}
                    readOnly={readOnly}
                />
            : null}

            {values.data_type === 'boolean' ?
                <RowsMaskBoolean
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />
            : null}


            <Col xs={6} />
        </Row>
    </div>
)}


const RowsMaskBoolean = ({values, errors, handleChange, readOnly}) => {

    if (values.booleanTrue.length > 0 && values.booleanFalse.length > 0) {
        values.mask_field = values.booleanTrue + "|" + values.booleanFalse
    }

    return (
        <div>
            <p>Construa a máscara do campo boolean</p>
            <br/>
            <Row className="mb-3">
                <ControlWithValidation Col={Col}
                    key="booleanTrue"
                    type="text"
                    label="Qual o valor verdadeiro?"
                    name="booleanTrue"
                    placeholder=""
                    value={values.booleanTrue}
                    error={errors.booleanTrue}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />

                <ControlWithValidation Col={Col}
                    key="booleanFalse"
                    type="text"
                    label="Qual o valor falso?"
                    name="booleanFalse"
                    placeholder=""
                    value={values.booleanFalse}
                    error={errors.booleanFalse}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />

                <Col xs={6} />
            </Row>
        </div>
)}


const RowsMaskDate = ({values, errors, handleChange, readOnly, buildMaskDateTime }) => {
    const { sequence, monthOptions } = buildMaskDateTime(values, "date")

    return (
        <div>
            <p>Construa a máscara do campo date</p>
            <br/>
            <Row className="mb-3">
                <SelectWithValidationKeyValeu
                    key="month"
                    Col={Col}
                    type="text"
                    label="Formato do mês"
                    name="month"
                    placeholder=""
                    value={values.month}
                    error={errors.month}
                    handleChange={handleChange}
                    options={monthOptions}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidation
                    key="delimiterDate"
                    Col={Col}
                    type="text"
                    label="Separador da data"
                    name="delimiterDate"
                    placeholder=""
                    value={values.delimiterDate}
                    error={errors.delimiterDate}
                    handleChange={handleChange}
                    options={["", ".", "/", "-", "sem separador"]}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidation
                    key="sequence"
                    Col={Col}
                    type="text"
                    label="Ordem"
                    name="sequence"
                    placeholder=""
                    value={values.sequence}
                    error={errors.sequence}
                    handleChange={handleChange}
                    options={sequence}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <ControlWithValidation Col={Col}
                    key="sample_mask"
                    type="text"
                    label="Máscara do campo date"
                    name="sample_mask"
                    placeholder=""
                    value={values.sample_mask}
                    error={errors.sample_mask}
                    handleChange={handleChange}
                    readOnly={true}
                />

            </Row>
        </div>
    )
}

const RowsMaskDatetime = ({values, errors, handleChange, readOnly, buildMaskDateTime }) => {
    const { sequence, monthOptions } = buildMaskDateTime(values, "datetime")

    return (
        <div>
            <p>Construa a máscara do campo date</p>
            <br/>
            <Row className="mb-3">
                <SelectWithValidationKeyValeu
                    key="month_"
                    Col={Col}
                    type="text"
                    label="Formato do mês"
                    name="month"
                    placeholder=""
                    value={values.month}
                    error={errors.month}
                    handleChange={handleChange}
                    options={monthOptions}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidation
                    key="delimiterDate_"
                    Col={Col}
                    type="text"
                    label="Separador da data"
                    name="delimiterDate"
                    placeholder=""
                    value={values.delimiterDate}
                    error={errors.delimiterDate}
                    handleChange={handleChange}
                    options={["", ".", "/", "-", "sem separador"]}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidation
                    key="sequence_"
                    Col={Col}
                    type="text"
                    label="Ordem da data"
                    name="sequence"
                    placeholder=""
                    value={values.sequence}
                    error={errors.sequence}
                    handleChange={handleChange}
                    options={sequence}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidationKeyValeu
                    key="delimiterDateTime"
                    Col={Col}
                    type="text"
                    label="Separador de data e hora"
                    name="delimiterDateTime"
                    placeholder=""
                    value={values.delimiterDateTime}
                    error={errors.delimiterDateTime}
                    handleChange={handleChange}
                    options={[{"value":"", "option": ""}, {"value": "_", "option": "_"}, {"value":"T", "option": "T"}, {"value":"t", "option": "t"}, {"value": ",", "option": ","}, {"value": " ", "option": "espaço único"}, {"value": "sem separador", "option":"sem separador"}]}
                    typeColumn="xs"
                    valueColumn={3}
                    readOnly={readOnly}
                />

                <SelectWithValidationKeyValeu
                    key="delimiterTime"
                    Col={Col}
                    type="text"
                    label="Separador da hora"
                    name="delimiterTime"
                    placeholder=""
                    value={values.delimiterTime}
                    error={errors.delimiterTime}
                    handleChange={handleChange}
                    options={[{"value":"", "option": ""}, {"value": ":", "option": ":"}, {"value": "sem separador", "option":"sem separador"}]}
                    typeColumn="xs"
                    valueColumn={3}
                    readOnly={readOnly}
                />
            </Row>
            <Row className="mb-3">
                <ControlWithValidation Col={Col}
                    key="sample_mask_"
                    type="text"
                    label="Máscara do campo datetime"
                    name="sample_mask"
                    placeholder=""
                    value={values.sample_mask}
                    error={errors.sample_mask}
                    handleChange={handleChange}
                    readOnly={true}
                />

                <Col xs={8} />
            </Row>
        </div>
    )
}


const TableCustom = ({ 
    handleAddRow, 
    tableHidden, 
    fields, 
    onEditField, 
    onDeleteField,
    readOnly=false
}) => {
    const columns = [
        '#', 
        'Nome do campo', 
        'Tipo do dado', 
        'Descrição', 
        // 'Descrição dos códigos', 
        // 'Máscara do campo', 
        'LGPD', 
        'Exemplo', 
        'Status', 
        'Ações'
    ]

    const fieldsCustom = fields.map((item, index) => {
        return (item.des_field && item.LGPD) ? {...item, status: true, id: index} : item
    })

    return (
        <div>
            {!readOnly ?
                <div className="mf-register-container-btn">
                    <Button className='btn-next btn-icon-text' variant="secondary" onClick={handleAddRow}>
                        <MdAddCircle className='btn-icon' />
                        Campo
                    </Button>
                </div>
            : null}

            <Table striped bordered hover className={tableHidden}>
                <thead>
                    <tr>
                        {columns.map((item, index) => (
                            <th>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {fieldsCustom.map((row, index) => (
                        <tr>
                            <td>{row.id}</td>
                            <td>{row.name_field}</td>
                            <td>{row.data_type}</td>
                            <td>{row.des_field}</td>
                            {/* <td>{row.descriptionCode}</td> */}
                            {/* <td>{row.mask_field}</td> */}
                            <td>{row.LGPD}</td>
                            <td>{row.example}</td>
                            <td>{row.status ? 
                                    <AiOutlineCheck size={20} className="mf-register-ok-status" /> 
                                :
                                    <AiOutlineClose size={20} className="mf-register-nok-status" />}
                            </td>
                            {!readOnly ?
                                <td className="mf-register-actions">
                                    <AiFillEdit size={20} className="mf-register-edit" onClick={() => onEditField(row)} />
                                    <AiFillDelete size={20} className="mf-register-delete" onClick={() => onDeleteField(row)} />
                                </td>
                                :
                                <td  className="mf-register-actions">
                                    <MdSlideshow size={20} className="mf-register-edit" onClick={() => onEditField(row)} />    
                                </td>}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default TableFields;